import { ECompatibilityReportType } from 'affiny-core/modules/api/models/member/member.types';
import { useCheckTrad } from 'affiny-desktop/src/hooks';
import { Box, Flex, rem, Score, Text, Title } from 'affiny-ui/src';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface ICompatibilityReportIntro {
  reportType: ECompatibilityReportType;
  score: number;
  nickname: string;
}

export const CompatibilityReportIntro = ({
  reportType,
  score,
  nickname,
}: ICompatibilityReportIntro) => {
  const { t } = useTranslation();
  const subDescription = useCheckTrad(
    `compatibilityReport.${reportType}.subDesc`,
    {
      nickname,
    }
  );

  return (
    <Box>
      <Title fontSize={rem(30)} mb="xLarge">
        {t(`compatibilityReport.${reportType}.title`)}
      </Title>
      <Flex>
        <Box mr={rem(45)}>
          <SText fontSize={rem(18)} mb="xLarge">
            {/* We use Trans here because a part of description (score) is displayed with <strong> tag in i18n locales */}
            <Trans
              i18nKey={`compatibilityReport.${reportType}.description`}
              values={{ score, nickname }}
            />
          </SText>
          {!!subDescription && (
            <Text fontSize={rem(18)} lineHeight={rem(28)}>
              {subDescription}
            </Text>
          )}
        </Box>
        <Score size={148} value={score} showLabel={false} />
      </Flex>
    </Box>
  );
};

const SText = styled(Text)`
  strong {
    color: ${({ theme }) => theme.colors.accent};
  }
`;
